export default ({ request }) => ({
    userBizContactFormListApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/list',
        method: 'post',
        data,
      })
    },
    userBizContactFormSaveApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/save',
        method: 'post',
        data,
      })
    },
    userBizContactFormDetailApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/detail',
        method: 'post',
        data,
      })
    },
    userBizContactFormDelApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/del',
        method: 'post',
        data,
      })
    },
    userBizContactFormItemListApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/item/list',
        method: 'post',
        data,
      })
    },
    userBizContactFormDocListApi(data = {}) {
      return request({
        url: '/digitalCenter/user/biz/contact/form/doc/list',
        method: 'post',
        data,
      })
    },
    userBizContactFormSubmitOaApplyApi(data = {}) {
      return request({
        url: '/oa/user/biz/contact/form/apply',
        method: 'post',
        data,
      })
    },
  })
  